<template>
  <transition name="none" appear mode="out-in">
    <vs-alert :active.sync="cActive" title="Meet FocusOKR" closable :key="`step${currentStep}`">
      <div>
        <span v-show="currentStep === 0">
          <p>{{ $t(`OKRInstruction.Step0.p1`) }}</p>
          <p>{{ $t(`OKRInstruction.Step0.p2`) }}</p>
          <p>{{ $t(`OKRInstruction.Step0.p3`) }}</p>
        </span>
        <span v-show="currentStep === 1">
          <p>{{ $t(`OKRInstruction.Step1.p1`) }}</p>
          <p v-html="$t(`OKRInstruction.Step1.p2`)"></p>
          <ul>
            <li>{{ $t(`OKRInstruction.Step1.li1`) }}</li>
            <li>{{ $t(`OKRInstruction.Step1.li2`) }}</li>
          </ul>
        </span>
        <span v-show="currentStep === 2">
          <p v-html="$t(`OKRInstruction.Step2.p1`)"></p>
          <ul>
            <li>{{ $t(`OKRInstruction.Step2.li1`) }}</li>
            <li>{{ $t(`OKRInstruction.Step2.li2`) }}</li>
          </ul>
        </span>
        <span v-show="currentStep === 3">
          <p>{{ $t(`OKRInstruction.Step3.p1`, { reminderDay, reminderHour }) }}</p>
          <p>{{ $t(`OKRInstruction.Step3.p2`) }}</p>
        </span>

        <div class="flex justify-end content-end">
          <vs-button
            size="small"
            icon-pack="feather"
            icon="icon-chevrons-left"
            color="primary"
            type="border"
            class="mr-3"
            @click="currentStep -= 1"
            :disabled="currentStep === 0"
          >{{ $t('General.Previous') }}</vs-button>

          <vs-button
            size="small"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            color="primary"
            type="border"
            @click="currentStep += 1"
            :disabled="currentStep === maxSteps"
          >{{ $t('General.Next') }}</vs-button>
        </div>
      </div>
    </vs-alert>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    currentStep: 0,
    maxSteps: 3
  }),
  computed: {
    cActive: {
      get() {
        return this.active
      },
      set(value) {
        this.$emit('update:active', value)
      }
    },
    reminderDay() {
      const day = this.$store.getters['account/days'].find(
        element => element.key === this.$store.state.account.reminderDay
      )
      return day ? day.name : this.$t('General.Loading')
    },
    reminderHour() {
      const hour = this.$store.state.account.reminderHour
      return `${hour} (${this.convertToAmPm(hour)})`
    }
  },
  methods: {
    convertToAmPm(hour) {
      const sign = hour < 12 ? 'AM' : 'PM'
      const normalizedHour = hour % 12
      if (normalizedHour === 0) return `12${sign}`
      return `${normalizedHour}${sign}`
    }
  },
  mounted() {
    const payload = {
      notify: this.$vs.notify
    }
    this.$store.dispatch('account/observeCurrentUserSettings', payload)
  },
  destroyed() {
    this.$store.dispatch('account/stopSettingsObservers')
  }
}
</script>

